<template>
    <div class="ext-goods-nav-box">
        <ul>
            <li v-for="(vo,index) in nav_list" :key="index">
                <a @click="set_link(vo.id)" :class="[vo.id==select_id ? 'select' : '']">{{vo.title}}</a>
            </li>
        </ul>
    </div>
</template>

<script>
import $ from 'jquery'

export default {
  name: 'ExtLeftNav',
  data () {
    return {
      select_id: '',
      nav_list: [
        {
          id: '1',
          title: '推荐产品'
        }, {
          id: '2',
          title: '热销产品'
        }, {
          id: '3',
          title: '促销活动'
        }, {
          id: '4',
          title: '产品分区'
        }, {
          id: '0',
          title: '回到顶部'
        }
      ]
    }
  },
  mounted () {
    var params = this.$route.query
    if (params.classid) {
      this.select_id = params.classid
    }

    var divWidth = ($(window).width() - 1200) / 2 - 95
    $('.ext-goods-nav-box').css('left', divWidth + 'px')
  },
  methods: {
    set_link (id) {
      this.select_id = id
      $('html,body').stop(true)
      $('html,body').animate({scrollTop: $('#map_' + id).offset().top}, 100)
    }
  }
}
</script>
<style scoped>
header,section,footer,div,ul,ol,li,img,a,span,em,del,legend,center,strong,var,fieldset,form,label,dl,dt,dd,cite,input,hr,time,mark,code,figcaption,figure,textarea,h1,h2,h3,h4,h5,h6,p{
    display:-moz-box;
    display: box;
    display: -webkit-box;
    font-family: "Noto Sans SC";
    display: inline-flex;
}

a { text-decoration:none; }

.ext-goods-nav-box { width:80px; height:auto; position: fixed; background: #f6f6f6; border:1px solid #dfdfdf; left:5px; top:200px;}
    .ext-goods-nav-box ul { width:100%; height:auto; margin:0px; padding:0px; list-style:none; flex-wrap:wrap; align-content:flex-start;}
    .ext-goods-nav-box ul li { width:100%; height:30px; margin:0px; padding:0px; line-height:30px;}
    .ext-goods-nav-box ul li a { width:100%; height:30px; cursor: pointer; font-size:14px; padding:0px 10px; line-height:30px; color:#333333;}
    .ext-goods-nav-box ul li a:hover { color:#ffffff; background: #d81e06;}
    .ext-goods-nav-box ul li a.select { color:#ffffff; background: #d81e06;}

</style>



// WEBPACK FOOTER //
// src/components/leftnav/leftnav.vue